// extracted by mini-css-extract-plugin
export default {"Portfolio":"Portfolio_Portfolio__FiCb5","Container":"Portfolio_Container__vz8NV"};